// extracted by mini-css-extract-plugin
export var bodyRow = "_e1-d";
export var cardColumns = "_e1-e";
export var ellipsesOverflow = "_e1-2";
export var flatBottomCorners = "_e1-3";
export var flatTopCorners = "_e1-4";
export var headerActionsDropdown = "_e1-f";
export var headerBottomRow = "_e1-c";
export var headerTopRow = "_e1-b";
export var orderDetailsWrapper = "_e1-0";
export var orderInfoContainer = "_e1-1";
export var productDetails = "_e1-9";
export var productImage = "_e1-5";
export var responsiveTable = "_e1-8";
export var shipmentContainer = "_e1-a";
export var tableBottomLeft = "_e1-6";
export var tableBottomRight = "_e1-7";